import { getCategoryFromLocationPath, getFeedSortFromSearchParams } from '../../utils/url';
import { FEED_INITIAL_STATE, Slices } from '../slices';

import { StateSchema } from './StoreProvider.types';

export const getInitialState = (locationPath?: string, searchParams?: URLSearchParams): Partial<StateSchema> => {
    const path = locationPath ?? window.location.pathname;
    const params = searchParams ?? new URLSearchParams(window.location.search);

    const category = getCategoryFromLocationPath(path);
    const sort = getFeedSortFromSearchParams(params);

    return {
        [Slices.Feed]: {
            ...FEED_INITIAL_STATE,
            category: category ?? FEED_INITIAL_STATE.category,
            sort: sort ?? FEED_INITIAL_STATE.sort,
        },
    };
};
